import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CourierExecutiveService} from '../../../shared/services/courier-executive.service';
import {AlertService} from '../../../shared/services/alert.service';
import {StorageService} from '../../../shared/services/storage.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-add-courier-executive',
  templateUrl: './add-courier-executive.component.html',
  styleUrls: ['./add-courier-executive.component.scss']
})
export class AddCourierExecutiveComponent implements OnInit {
  addCourierExecutiveForm: FormGroup;
  submitted: any = false;
  submitting: any = false;
  inputTypePassword: any = 'password';
  user: any;
  id: any;

  constructor(private router: Router,
              private fb: FormBuilder,
              private courierExecutiveService: CourierExecutiveService,
              public activatedRoute: ActivatedRoute,
              private alertService: AlertService,
              private _location: Location) {
  }

  ngOnInit() {
    this.user = StorageService.getItem('self');
    if (this.user.user_type !== 'SUPER_ADMIN' && this.user.user_type !== 'ADMIN') {
      this.router.navigateByUrl('');
    }
    this.id = this.activatedRoute.snapshot.params['id'];
    this.refresh();
  }

  refresh() {
    this.addCourierExecutiveForm = this.fb.group({
      'name': ['', Validators.required],
      'username': ['', (!this.id) ? Validators.required : ''],
      'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
      'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
      'password': ['', (!this.id) ? Validators.required : '']
    });

    if (this.id) {
      this.detail(this.id);
    }
  }

  detail(id) {
    this.courierExecutiveService.detail(parseInt(id)).subscribe(data => {
      if (data) {
        this.addCourierExecutiveForm.patchValue({
          'name': (data && data.name) ? data.name : '',
          'username': (data && data.username) ? data.username : '',
          'email': (data && data.email) ? data.email : '',
          'contact': (data && data.contact) ? data.contact : ''
        });
      }
    }, error => {
      this.back();
    });
  }

  back() {
    // this.router.navigateByUrl('admins');
    this._location.back();
  }

  submit() {
    this.submitted = true;
    if (!this.addCourierExecutiveForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'name': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.name) ? this.addCourierExecutiveForm.value.name : '',
        'username': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.username) ? this.addCourierExecutiveForm.value.username : '',
        'email': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.email) ? this.addCourierExecutiveForm.value.email : '',
        'contact': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.contact) ? this.addCourierExecutiveForm.value.contact : '',
        'password': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.password) ? this.addCourierExecutiveForm.value.password : ''
      };
      this.submitting = true;
      this.courierExecutiveService.create(params).subscribe(data => {
        if (data) {
          this.submitting = false;
          this.submitted = false;
          this.back();
        }
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
            this.alertService.showErrors(error['error']['errors'].username[0]);
            return;
          }
          if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
            this.alertService.showErrors(error['error']['errors'].email[0]);
            return;
          }
          if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
            this.alertService.showErrors(error['error']['errors'].contact[0]);
            return;
          }
        }
      });
    }
  }

  update() {
    this.submitted = true;
    if (!this.addCourierExecutiveForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'name': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.name) ? this.addCourierExecutiveForm.value.name : '',
        'username': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.username) ? this.addCourierExecutiveForm.value.username : '',
        'email': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.email) ? this.addCourierExecutiveForm.value.email : '',
        'contact': (this.addCourierExecutiveForm.value && this.addCourierExecutiveForm.value.contact) ? this.addCourierExecutiveForm.value.contact : ''
      };
      this.submitting = true;
      this.courierExecutiveService.update(this.id, params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.back();
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
            this.alertService.showErrors(error['error']['errors'].username[0]);
            return;
          }
          if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
            this.alertService.showErrors(error['error']['errors'].email[0]);
            return;
          }
          if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
            this.alertService.showErrors(error['error']['errors'].contact[0]);
            return;
          }
        }
      });
    }
  }
}
